import { SCROLL_Y_POSITION } from '@theme/constants'

// if (!window.__motionRailGlobalsInit) {
//   window.__motionRailGlobalsInit = true;

//   window.addEventListener("pagehide", () => {
//     sessionStorage.setItem(SCROLL_Y_POSITION, String(window.scrollY));
//   });
// }